import axios from "axios";
import * as auth from "./auth";
import {findDOMNode} from "react-dom";
import {sleepy} from "./helpers";


const ticketingAjaxJson = axios.create({
    baseURL: process.env.REACT_APP_TICKETING_API_BASE_URL,
    timeout: 30000
});

const ajaxJson = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 40000
});

const OrganizationAjaxJson = axios.create({
    baseURL: process.env.REACT_APP_ORGANIZATION_API_BASE_URL,
    timeout: 30000
});

const androidAjaxJson = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 10000
});


const authHeaderReqInterceptor = [
    config => {
        if (auth.isLogin()) {
            config.headers["Authorization"] = `Bearer ${auth.getUser().token}`;
        } else {
            delete config.headers["Authorization"];
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
];

ajaxJson.interceptors.request.use(...authHeaderReqInterceptor);

export default ajaxJson;

const getMerchantId = () => {
    return localStorage.getItem("merchant");
};

const getSelectedMerchantDetail = () => {
    let merchant_detail = {
        "name": localStorage.getItem("merchant_name"),
        "payment_sdk_client_id": localStorage.getItem("merchant_payment_sdk_client_id"),
        "wallet_id": localStorage.getItem("merchant_wallet_id"),
        "acceptor": localStorage.getItem("acceptor"),
    }
    return merchant_detail
};

let Headers = {
    'Content-Type': 'application/json',
    'Authorization': getMerchantId(),
}


let ticketingHeaders = {
    'Content-Type': 'application/json',
    'Authorization': "kpus4hp982xg)l-3j$jnl87bqn302gbq@-j%&w9g*-mblz93ng",
}


export function getConditionsAndEffects() {
    return ajaxJson.get("fixtures/conditions_effects").then(res => {
        return res.data;
    });
}

export function getMerchantDetail() {
    return ajaxJson.get(`merchants/admin/${getMerchantId()}`).then(res => {
        return {
            id: res.data["uid"],
            name: res.data["name"],
            description: res.data["description"],
            subtitle: res.data["subtitle"],
            website: res.data["website"],
            address: res.data["address"],
            phone: res.data["phone"],
            hours: res.data["hours"],
            cover: res.data["cover"],
            balance: res.data["balance"],
            image: res.data["image"],
            mapImage: res.data["map_image"],
            thumbnail: res.data["thumbnail"],
            color: res.data["color"],
            type: res.data["type"],
            isGroupAccount: res.data["is_group_account"]
        };
    });
}

export function putMerchantDetail(data) {
    let formData = new FormData();
    console.log()
    if (data.mapImage instanceof File) {
        formData.set("map_image", data.mapImage);
    }
    data.name && formData.set("name", data.name);
    data.description && formData.set("description", data.description);
    data.subtitle && formData.set("subtitle", data.subtitle);
    data.website && formData.set("website", data.website);
    data.address && formData.set("address", data.address);
    data.phone && formData.set("phone", data.phone);
    data.hours && formData.set("hours", data.hours);
    data.color && formData.set("hours", data.color);
    return ajaxJson
        .put(`merchants/admin/${getMerchantId()}`, formData)
        .then(res => {
            return {
                id: res.data["uid"],
                name: res.data["name"],
                description: res.data["description"],
                subtitle: res.data["subtitle"],
                website: res.data["website"],
                address: res.data["address"],
                phone: res.data["phone"],
                hours: res.data["hours"],
                cover: res.data["cover"],
                image: res.data["image"],
                mapImage: res.data["map_image"],
                thumbnail: res.data["thumbnail"]
            };
        });
}

export function postMerchantImages(imagesFiles) {
    console.log(imagesFiles)
    let formData = new FormData();
    imagesFiles.cover && formData.set("cover", imagesFiles.cover);
    imagesFiles.image && formData.set("image", imagesFiles.image);
    imagesFiles.mapImage && formData.set("map_image", imagesFiles.mapImage);
    imagesFiles.thumbnail && formData.set("thumbnail", imagesFiles.thumbnail);
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/images`, formData)
        .then(res => {
            return {
                cover: res.data["cover"],
                image: res.data["image"],
                mapImage: res.data["map_image"],
                thumbnail: res.data["thumbnail"]
            };
        });
}

export function getClientsApi(options = {}) {
    const {page = 1} = options;

    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/users`, {
            params: {
                page: page
            }
        })
        .then(res => {
            const results = res.data["results"].map(item => {
                return {
                    id: item["uid"],
                    fullName: item["full_name"],
                    phoneNumber: item["phone"],
                    loyaltyPoint: item["score"],
                    invoiceAmountSum: item["total_transactions_amount"],
                    invoiceCount: item["total_transactions_count"],
                    topic: item["topic"],
                    image: item["image"]
                };
            });
            return {
                results,
                totalCount: res.data["count"],
                totalPage: res.data["total_pages"],
                currentPage: page
            };
        });
}

export function getCampaignsApi(options = {}) {
    const {
        page = 1,
        title,
        startBefore,
        startAfter,
        endBefore,
        endAfter,
        isActive,
        campActive,
        campExp
    } = options;
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/campaigns`, {
            params: {
                page: page,
                title: title,
                start_date_before: startBefore && startBefore.toISOString(),
                start_date_after: startAfter && startAfter.toISOString(),
                end_date_before: endBefore && endBefore.toISOString(),
                end_date_after: endAfter && endAfter.toISOString(),
                is_active: campActive,
                expired: campExp
            }
        })
        .then(res => {
            const results = res.data["results"].map(item => {
                return {
                    id: item["uid"],
                    uid: item["uid"],
                    rules: item["rules"],
                    title: item["title"],
                    image: item["thumbnail"],
                    start: item["start_date"],
                    end: item["end_date"],
                    isActive: item["is_active"],
                    created: item["created"],
                    merchantGroupId: item["merchant_group_uid"]
                };
            });
            return {
                results,
                totalCount: res.data["count"],
                totalPage: res.data["total_pages"],
                currentPage: page,
                count: res.data['count']
            };
        });
}

export function getCampaignStatisticsApi() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/campaign/statistics`)
        .then(res => {
            return {
                disable: res.data["disable"],
                enable: res.data["enable"],
                expired: res.data["expired"],
                notStarted: res.data["not_Started"],
                total: res.data["total"]
            };
        });
}

export function getCampaignApi(campaignId) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/campaign/${campaignId}/`)
        .then(res => {
            return {
                title: res.data["title"],
                description: res.data["description"],
                endAt: res.data["end_date"],
                startAt: res.data["start_date"],
                visibleFromDate: res.data["visible_from_date"],
                visibleToDate: res.data["visible_to_date"],
                isActive: res.data["is_active"],
                image: res.data["image"],
                cover: res.data["cover"],
                thumbnail: res.data["thumbnail"],
                rules: res.data["rules"].map(item => {
                    return {
                        id: item["uid"],
                        title: item["title"],
                        isForAllMerchants: item["is_for_all_merchants"],
                        isActive: item["is_active"],
                        conditions: item["conditions"].map(i => {
                            const id = i["uid"];
                            delete i["uid"];
                            return {
                                id,
                                ...i
                            };
                        }),
                        effects: item["effects"].map(i => {
                            return {
                                id: i["uid"],
                                ...i
                            };
                        }),
                        merchants: item["merchants"].map(i => {
                            return {
                                id: i["uid"],
                                name: i["name"]
                            };
                        })
                    };
                })
            };
        });
}


export function excelCampaignApi(campaignId) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/customers/export`, {
            params: {
                campaign_uid: campaignId
            }
        }
    );
}


export function deleteCampaignApi(campaignId) {
    return ajaxJson.delete(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/`
    );
}

export function deleteProductApi(productId) {
    return ajaxJson.delete(
        `merchant_admin/${getMerchantId()}/admin/products/${productId}`
    );
}

export function productDetailApi(productId) {
    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/products/${productId}`
    ).then(res => {
        return res.data
    });
}

export function getMessageBodyParametersApi(messageType) {
    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/messages/message-types/${messageType}/body-parameters`
    ).then(res => {
        return res.data
    });
}

// export function getMerchantDetailApi(uid) {
//     return ajaxJson.get(
//         `merchant_admin/${uid}/admin/`
//     ).then(res => {
//         return res.data
//     });
// }


export function getProductsCategoriesApi(parent = '') {
    let params = {}
    if (parent) {
        params.parent = parent
    } else {
        params.has_parent = false
    }
    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/products/categories`,
        {
            params
        }
    )
        .then(res => {
            return res.data
        });
}

export function activeCampaignApi(campaignId) {
    return ajaxJson.post(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/active`
    );
}

export function deactivateCampaignApi(campaignId) {
    return ajaxJson.post(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/deactivate`
    );
}

export function editDiscountCampaignApi(campaignId, obj) {
    return ajaxJson.patch(
        `/merchants/admin/${getMerchantId()}/product-campaign/${campaignId}/`, obj
    );
}

export function activeDiscountCampaignApi(campaignId, obj) {
    return ajaxJson.patch(
        `/merchants/admin/${getMerchantId()}/product-campaign/${campaignId}/`, obj
    );
}

export function deactivateDiscountCampaignApi(campaignId, obj) {
    return ajaxJson.patch(
        `/merchants/admin/${getMerchantId()}/product-campaign/${campaignId}/`, obj
    );
}

export function postCampaignApi(campaignObj) {
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/campaigns`, {
            title: campaignObj.title,
            description: campaignObj.description,
            start_date: campaignObj.startAt && campaignObj.startAt.toISOString(),
            end_date: campaignObj.endAt && campaignObj.endAt.toISOString(),
            visible_from_date: campaignObj.visibleFromDate || null,
            visible_to_date: campaignObj.visibleToDate || null,
            send_notif: campaignObj.sendNotif
        })
        .then(res => {
            return {
                id: res.data["uid"]
            };
        });
}

export function putCampaignApi(campaignObj, campaignId) {
    return ajaxJson
        .put(`merchants/admin/${getMerchantId()}/campaign/${campaignId}/`, {
            title: campaignObj.title,
            description: campaignObj.description,
            start_date:
                campaignObj.startAt && campaignObj.startAt.toISOString(true),
            end_date: campaignObj.endAt && campaignObj.endAt.toISOString(true),
            visible_from_date: campaignObj.visibleFromDate || null,
            visible_to_date: campaignObj.visibleToDate || null
        })
        .then(res => {
            return {
                id: res.data["uid"]
            };
        });
}

export function postCampaignImageApi(campaignId, campaignImagesFile) {


    let formData = new FormData();


    campaignImagesFile.image &&
    typeof campaignImagesFile.image !== "string" &&
    formData.set("image", campaignImagesFile.image);


    campaignImagesFile.cover &&
    typeof campaignImagesFile.cover !== "string" &&
    formData.set("cover", campaignImagesFile.cover);

    campaignImagesFile.thumbnail &&
    typeof campaignImagesFile.thumbnail !== "string" &&
    formData.set("thumbnail", campaignImagesFile.thumbnail);

    campaignImagesFile.mobile_banner &&
    typeof campaignImagesFile.mobile_banner !== "string" &&
    formData.set("mobile_banner", campaignImagesFile.mobile_banner);

    campaignImagesFile.banner &&
    typeof campaignImagesFile.banner !== "string" &&
    formData.set("banner", campaignImagesFile.banner);

    !campaignImagesFile.image && formData.set("image", new File([""], ""));
    !campaignImagesFile.cover && formData.set("cover", new File([""], ""));
    !campaignImagesFile.thumbnail && formData.set("thumbnail", new File([""], ""));
    !campaignImagesFile.banner && formData.set("banner", new File([""], ""));
    !campaignImagesFile.mobile_banner && formData.set("mobile_banner", new File([""], ""));

    return ajaxJson.put(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/images`,
        formData,{
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
    );
}



export function getInvoicesApi(options = {}) {
    const {page = 1, search, startDate, endDate} = options;
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/invoices`, {
            params: {
                search: search,
                page: page,
                paid_at_after: startDate && startDate.toISOString(),
                paid_at_before: endDate && endDate.toISOString()
            }
        })
        .then(res => {
            return {
                totalPage: res.data["total_pages"],
                count: res.data["count"],
                results: res.data["results"].map(i => ({
                    id: i["id"],
                    user: i["user"],
                    amount: i["amount"],
                    discount: i["discount_amount"],
                    payableAmount: i["payable_amount"],
                    payedAt: i["paid_at"],
                    createAt: i["created"],
                    description: i["description"],
                    state: i["state"],
                    order: i['order'],
                    products: i['products'],
                    client_discount_amount: i["client_discount_amount"]
                }))
            };
        });
}

// export function loginApi(phoneNumber) {
//     return ajaxJson
//         .post(`users/auth`, {
//             phone: phoneNumber
//         })
//         .then(res => {
//             return res.data["token"];
//         });
// }

export function loginApi(phoneNumber) {
    return ajaxJson
        .post(`merchant_admin/auth`, {
            phone: phoneNumber
        })
        .then(res => {
            return res.data["token"];
        });
}


export function sendOtpApi(phoneNumber) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/add-user/auth`, {
            phone: phoneNumber
        })
        .then(res => {
            return res.data["token"];
        });
}

export function addNewUser_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/add-user/auth/verification`, obj)
        .then(res => {
            return res.data;
        });
}

export function getSurveyListApi(page) {
    return ajaxJson
        .get(`polls/`, {
            params: {
                merchant_uid: getMerchantId()
            }
        })
        .then(res => {
            return res.data;
        });
}


// export function loginVerificationApi(token, code) {
//     return ajaxJson
//         .post(`users/auth/verification`, {
//             token: token,
//             code: Number(code)
//         })
//         .then(res => {
//             return {
//                 token: res.data["access_token"],
//                 phoneNumber: res.data["phone"],
//                 id: res.data["uid"],
//                 image: res.data["image"],
//                 fullName: res.data["first_name"] + " " + res.data["last_name"]
//             };
//         });
// }

export function loginVerificationApi(token, code) {
    return ajaxJson
        .post(`merchant_admin/auth/verification`, {
            token: token,
            code: Number(code)
        })
        .then(res => {
            return {
                token: res.data["access_token"],
                phoneNumber: res.data["phone"],
                id: res.data["uid"],
                image: res.data["image"],
                fullName: res.data["first_name"] + " " + res.data["last_name"]
            };
        });
}

export function getUserMerchantsApi() {
    return ajaxJson.get(`users/merchants`).then(res => {
        return res.data.map(item => {
            return {
                id: item["uid"],
                name: item["name"],
                mallName: item["mall_name"],
                mall_uid: item["mall_uid"],
                subtitle: item["subtitle"],
                phone: item["phone"],
                wallet_id: item["wallet_id"],
                website: item["website"],
                payment_sdk_client_id: item["payment_sdk_client_id"],
                acceptor: item["acceptor"],
                thumbnail: item["thumbnail"],
                type: item["type"],
                permissions: item["permissions"]
            };
        });
    });
}

export function getMerchantProductsApi(options = {}) {
    let {
        page = 1,
        page_size = 5,
        searchText,
        selectedCategory,
        ordering,
        isActive,
        hasStock,
        status,
        tag,
        tagFilter,
        priceGt = null,
        stockGt = null
    } = options;
    console.log("tagFilter : ", tagFilter)
    console.log("tag : ", tag)
    // if(tag && tag.length>0 && tag!=="all" && tagFilter?.length<1)
    //     tagFilter = [{uid:tag}]


    let tagF = "";
    let params = {
        page: page,
        status: status,
        page_size: page_size,
        search: searchText,
        ordering: ordering,
        is_available: hasStock !== 'all' ? hasStock : null
    }
    if (selectedCategory !== 'null') {
        params.category_level_one__uid = selectedCategory
    }
    if (isActive !== 'null') {
        params.is_active = isActive
    }

    if (tag && tag !== "all") {
        if (!tagFilter)
            params['product_tag__uid'] = tag
    }


    if (tag && tag !== "all") {
        if (!tagFilter)
            params['product_tag__uid'] = tag
    }

    if (priceGt) {
        params['price__gt'] = 0
    }
    if (stockGt) {
        params['stock__gt'] = 0
    }


    if (tagFilter && tagFilter.length > 0) {
        tagFilter.forEach(t => {
            tagF += "&product_tag__uid=" + t.uid
        })
    }


    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/products?${tagF}`,
        {
            params: {
                ...params
            }
        }
    ).then(res => {
        return res.data
    });
}


export function getMerchantMatchingProductsApi(options = {}) {
    let {
        page = 1,
        page_size = 5,
        searchText,
        selectedCategory,
        ordering,
        isActive,
        hasStock,
        status,
        tag,
        tagFilter,
        priceGt = null,
        stockGt = null
    } = options;
    console.log("tagFilter : ", tagFilter)
    console.log("tag : ", tag)
    // if(tag && tag.length>0 && tag!=="all" && tagFilter?.length<1)
    //     tagFilter = [{uid:tag}]


    let tagF = "";
    let params = {
        page: page,
        page_size: page_size,
        search: searchText,
        sort: ordering,
        is_available: hasStock !== 'all' ? hasStock : null
    }
    if (selectedCategory !== 'null') {
        params.category_level_one__uid = selectedCategory
    }
    if (isActive !== 'null') {
        params.product_is_active = isActive
    }
    if (status !== 'null') {
        params.compare_status = status
    }


    if (tag && tag !== "all") {
        if (!tagFilter)
            params['product_tag__uid'] = tag
    }


    if (tag && tag !== "all") {
        if (!tagFilter)
            params['product_tag__uid'] = tag
    }

    if (priceGt) {
        params['price__gt'] = 0
    }
    if (stockGt) {
        params['stock__gt'] = 0
    }


    if (tagFilter && tagFilter.length > 0) {
        tagFilter.forEach(t => {
            tagF += "&product_tag__uid=" + t.uid
        })
    }


    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/comparison-results/`,
        {
            params: {
                ...params
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getMerchantDetailApi() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/`).then(res => {
        return res.data
    });
}


export function getMerchantDetailV2Api() {
    return ajaxJson.get(`merchants/admin/${getMerchantId()}`).then(res => {
        return res.data
    });
}

export function editMerchantDetailV2Api(obj) {
    return ajaxJson.put(`merchants/admin/${getMerchantId()}`, obj).then(res => {
        return res.data
    });
}

export function getMerchantDetailMainApi() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/?mainpanel=true`).then(res => {
        return res.data
    });
}

export function getMedCountApi() {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/med-orders/count/`, {status: [1, 3]}).then(res => {
        return res.data
    });
}

export function getShopCountApi() {
    return ajaxJson.post(`merchants/admin/${getMerchantId()}/shop_orders/count/`, {status: [3]}).then(res => {
        return res.data
    });
}

export function createUserWithPhone(user) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/users`,
        {
            "phone": user.clientPhoneNumber,
            "first_name": user.clientFirstName,
            "last_name": user.clientLastName,
            "birthday_date": user.clientBirthday,
            "email": "",
            "gender": user.clientGender
        }
    ).then(res => {
        return res.data
    });
}

export function EditUser(user) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/users/${user.clientId}`,
        {
            "first_name": user.clientFirstName,
            "last_name": user.clientLastName,
            "birthday_date": user.clientBirthday,
            "email": "",
            "gender": user.clientGender
        }
    ).then(res => {
        return res.data
    });
}

export function getUserByPhoneNumber(phoneNumber) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/user`, {
            params: {phone: phoneNumber}
        })
        .then(res => {
            return {
                id: res.data["uid"],
                fistName: res.data["first_name"],
                lastName: res.data["last_name"],
                email: res.data["email"],
                gender: res.data["gender"],
                birthday: res.data["birthday_date"],
                coupons:
                    res.data["coupons"] &&
                    res.data["coupons"].map(item => {
                        return {
                            id: item["uid"],
                            title: item["title"],
                            code: item["code"]
                        };
                    })
            };
        });
}


export function getUserByNameAndPhoneNumber(phoneNumber = null, name = null) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/user_search`, {
            params: {
                phone: phoneNumber,
                name: name
            }
        })
        .then(res => {
            return res.data.results
        });
}


export function submitInvoice(invoice) {
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/create_invoice`, {
            amount: parseInt(invoice.price),
            created: invoice.created,
            description: invoice.description,
            coupon_code: invoice.discountCode,
            products: invoice.products,
            client_discount_amount: invoice.client_discount_amount,
            user_uid: invoice.clientId,
            user_phone: invoice.clientPhoneNumber,
            user_name: invoice.clientFirstName,
            user_family: invoice.clientLastName,
            user_birthday: invoice.clientBirthday,
            user_email: invoice.clientEmail,
            user_gender: invoice.clientGender,
        })
        .then(res => {
            return {
                full: res.data,
                id: res.data["invoice"]["uid"],
                payableAmount:
                    res.data["invoice"] &&
                    res.data["invoice"]["payable_amount"],
                discountAmount:
                    res.data["invoice"] &&
                    res.data["invoice"]["discount_amount"],
                amount: res.data["invoice"] && res.data["invoice"]["amount"],
                client_discount_amount: res.data["invoice"]["client_discount_amount"],
                calculationLog:
                    res.data["invoice"] &&
                    res.data["invoice"]["calculation_log"].map(item => {
                        return {
                            id: item["effect_uid"],
                            title: item["effect_title"],
                            discountAmount: item["discount_amount"],
                            discountValue: item["discount_value"]
                        };
                    }),
                rewards: res.data["rewards"].map(item => {
                    return {
                        id: item["uid"],
                        title: item["campaign_title"],
                        value: item["effect"]["coupon_template"] ? item["effect"]["coupon_template"]["discount_value"] : 0,
                        effect: item["effect"]["effect"]
                    };
                })
            };
        });
}

export function verifyInvoice(invoiceId) {
    console.log(invoiceId);
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/verify_invoice`, {
            invoice_uid: invoiceId
        })
        .then(res => {
            return res.data;
        });
}


export function updateProductPrice(id, obj) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${id}`, obj)
        .then(res => {
            return res.data;
        });
}


export function generateReferralLink(obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/links`, obj)
        .then(res => {
            return res.data;
        });
}

export function getLinksApi(page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/link_report`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}


export function getLinksDetailApi(id) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/link_report/${id}`)
        .then(res => {
            return res.data;
        });
}

export function getCouponsApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/coupons`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return {
                totalPage: res.data["total_pages"],
                count: res.data["count"],
                results: res.data["results"].map(i => ({
                    id: i["uid"],
                    campaign: i["campaign"] && {
                        id: i["campaign"]["uid"],
                        title: i["campaign"]["title"],
                        cover: i["campaign"]["cover"],
                        created: i["campaign"]["created"],
                        image: i["campaign"]["image"],
                        endAt: i["campaign"]["end_date"],
                        isActive: i["campaign"]["is_active"],
                        isFeatured: i["campaign"]["is_featured"],
                        order: i["campaign"]["order"],
                        startAt: i["campaign"]["start_date"],
                        thumbnail: i["campaign"]["thumbnail"]
                    },
                    category: i["category"] && {
                        id: i["category"]["uid"],
                        title: i["category"]["title"],
                        description: i["category"]["description"],
                        merchant: i["category"]["merchant"],
                        created: i["category"]["created"]
                    },
                    merchants: i["merchants"],
                    consume_type: i["consume_type"],
                    code: i["code"],
                    type: i["coupon_type"],
                    description: i["description"],
                    amount: i["discount_value"],
                    owner: i["owner"] && {
                        fullName: i["owner"]["full_name"],
                        phone: i["owner"]["phone"]
                    },
                    title: i["title"],
                    isValid: i["is_redeemable"],
                    maxDiscountAmount: i["max_discount_amount"],
                    validFrom: i["valid_from_date"],
                    validTo: i["valid_to_date"],
                    redemptionLimit: i["redemption_limit"],
                    remainRedeemCount: i["remain_redeem_count"],
                    redeemCount: i["redeem_count"]
                }))
            };
        });
}

export function getCouponCategory() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/coupon_categories`)
        .then(res => {
            return res.data;
        });
}

export function createCouponCategory(category) {
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/coupon_categories`, {
            label: category
        })
        .then(res => {
            return res.data;
        });
}

export function createCoupon(couponData) {
    let formData = new FormData();

    for (var i = 0; i < couponData.merchants.length; i++) {
        formData.append(`merchants`, couponData.merchants[i].value);
    }
    formData.append("title", couponData.title);
    formData.append("description", couponData.description);
    // formData.append("owner", couponData.owner || null);
    formData.append("category", couponData.category);
    formData.append("campaign", couponData.campaign);
    formData.append("valid_from_date", couponData.validFrom);
    formData.append("valid_to_date", couponData.validTo);
    formData.append("code", couponData.code);
    formData.append("redemption_limit", couponData.redemptionLimit);
    if (couponData.discountValue) {
        formData.append("discount_value", couponData.discountValue);
    }
    formData.append("coupon_type", couponData.type);
    if (couponData.maxDiscountAmount) {
        formData.append("max_discount_amount", couponData.maxDiscountAmount);
    }
    if (couponData.rewardItem) {
        formData.append("reward_item", couponData.rewardItem.value);
    }
    if (couponData.phone) {
        formData.append("phone", couponData.phone);
    }
    formData.append("consume_type", couponData.consumeType);
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/coupons`, formData)
        .then(res => {
            console.log(res.data);
            return res.data;
        });
}

export function createCouponBatch(couponData) {
    let formData = new FormData();

    for (var i = 0; i < couponData.merchants.length; i++) {
        formData.append(`merchants`, couponData.merchants[i].value);
    }
    formData.append("title", couponData.title);
    formData.append("description", couponData.description);
    // formData.append("owner", couponData.owner || null);
    formData.append("category", couponData.category);
    formData.append("campaign", couponData.campaign);
    formData.append("valid_from_date", couponData.validFrom);
    formData.append("valid_to_date", couponData.validTo);
    formData.append("code", couponData.code);
    formData.append("redemption_limit", couponData.redemptionLimit);

    if (couponData.discountValue) {
        formData.append("discount_value", couponData.discountValue);
    }
    formData.append("coupon_type", couponData.type);
    if (couponData.maxDiscountAmount) {
        formData.append("max_discount_amount", couponData.maxDiscountAmount);
    }
    formData.append("consume_type", couponData.consumeType);
    formData.append("number_of_coupons", couponData.numberOfCoupons);
    if (couponData.prefix) {
        formData.append("prefix", couponData.prefix);
    }
    if (couponData.postfix) {
        formData.append("postfix", couponData.postfix);
    }
    formData.append("code_length", couponData.codeLength);
    formData.append("allowed_chars", couponData.allowedChars);
    formData.append("owner_limit", couponData.ownerLimit);
    formData.append("consume_type", couponData.consumeType);
    if (couponData.rewardItem) {
        formData.append("reward_item", couponData.rewardItem.value);
    }
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/coupon_batches`, formData)
        .then(res => {
            return res.data;
        });
}

export function getSellInfo() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/info_sell`)
        .then(res => {
            return {
                all: {
                    count: res.data["all"]["count"],
                    sum: res.data["all"]["sum"]
                },
                lastWeek: {
                    count: res.data["last_7_day"]["count"],
                    sum: res.data["last_7_day"]["sum"]
                },
                lastMonth: {
                    count: res.data["last_30_day"]["count"],
                    sum: res.data["last_30_day"]["sum"]
                },
                today: {
                    count: res.data["today"]["count"],
                    sum: res.data["today"]["sum"]
                }
            };
        });
}

export function getInfoCampaign() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/info_campaign`)
        .then(res => {
            return res.data.map(item => {
                return {
                    sellCount: item["report"]["sell_count"],
                    newUserCount: item["report"]["new_user"],
                    sumAmount: item["report"]["sum_amount"],
                    sumDiscount: item["report"]["sum_discount"],
                    couponCount: item["report"]["coupons_count"],
                    couponUsedCount: item["report"]["redeem_coupon_count"],
                    title: item["title"],
                    start: item["start_date"],
                    end: item["end_date"]
                };
            });
        });
}

export function createCondition(conditionData, campaignId) {
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/campaign/${campaignId}/conditions`,
            conditionData
        )
        .then(res => {
            return {
                id: res.data["uid"],
                title: res.data["title"]
            };
        });
}

export function createEffect(effectData, campaignId) {
    console.log(effectData)
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/campaign/${campaignId}/effects`,
            effectData
        )
        .then(res => {
            return {
                id: res.data["uid"],
                title: res.data["title"]
            };
        });
}

export function createRule(rule, campaignId, selectedMerchants, isForAllMerchants) {
    const conditions = rule.conditions.map(i => i.id);
    const effects = rule.effects.map(i => i.id);
    const merchants = selectedMerchants.map(i => i.value);
    let data = {
        conditions: conditions,
        effects: effects,
        merchants: merchants,
        is_for_all_merchants: isForAllMerchants,
    }
    if (rule.trigger) {
        data.trigger = rule.trigger.value
    }

    if (rule.every)
        data.every = rule.every

    if (rule.period)
        data.period = rule.period

    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/campaign/${campaignId}/rules`,
            data
        )
        .then(res => {
            return {
                id: res.data["uid"],
                conditions: res.data["conditions"],
                effects: res.data["effects"],
                title: res.data["title"],
                isUsabilityEqualToOne: res.data["is_usability_equal_to_one"],
                createAt: res.data["created"],
                merchants: res.data["merchants"]
            };
        });
}

export function activeRule(campaignId, ruleId) {
    return ajaxJson.post(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/rules/${ruleId}/activation/`
    )
}

export function deActiveRule(campaignId, ruleId) {
    return ajaxJson.post(
        `merchants/admin/${getMerchantId()}/campaign/${campaignId}/rules/${ruleId}/deactivation/`
    )
}

export function getLotteriesApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/lotteries`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getLotteryMemberApi(lotteryId, options = {}) {
    const {page = 1} = options;

    return ajaxJson
        .get(
            `merchants/admin/${getMerchantId()}/lottery/${lotteryId}/members/`,
            {
                params: {
                    page: page
                }
            }
        )
        .then(res => {
            const data = res.data;

            const results = data["results"].map(item => {
                return {
                    id: item["uid"],
                    fullName:
                        item["user"]["first_name"] +
                        " " +
                        item["user"]["last_name"],
                    phoneNumber: item["user"] && item["user"]["phone"],
                    points: item["campaign_points"],
                    codeCount: item["codes"] && item["codes"].length,
                    codes: item["codes"]
                };
            });
            return {
                results,
                totalCount: data["count"],
                totalPage: data["total_pages"],
                currentPage: page
            };
        });
}

export function createLotteryApi(lottery, image) {
    let formData = new FormData();
    const mapKeys = {
        campaign: "campaign_uid",
        title: "title",
        dateTime: "lottery_time",
        startCode: "code_start",
        winnerCount: "winner_count",
        uid: 'uid'
    };
    Object.keys(lottery).forEach(key => {
        lottery[key] && formData.set(mapKeys[key], lottery[key]);
    });
    image && formData.set("image", image);
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/lotteries`, formData)
        .then(res => res.data);
}

export function updateLotteryApi(lotteryId, lottery, image) {
    let formData = new FormData();
    const mapKeys = {
        campaign: "campaign_uid",
        title: "title",
        dateTime: "lottery_time",
        startCode: "code_start",
        winnerCount: "winner_count"
    };
    Object.keys(lottery).forEach(key => {
        lottery[key] && formData.set(mapKeys[key], lottery[key]);
    });
    image && formData.set("image", image);
    return ajaxJson
        .put(
            `merchants/admin/${getMerchantId()}/lottery/${lotteryId}`,
            formData
        )
        .then(res => res.data);
}

export function executeLotteryApi(lotteryId) {
    return ajaxJson.put(
        `merchants/admin/${getMerchantId()}/lotteries/execute`,
        {
            lottery_uid: lotteryId
        }
    );
}

export function setCouponOwnerApi(couponId, phone) {
    return ajaxJson.put(
        `merchants/admin/${getMerchantId()}/coupons/${couponId}/update-owner`,
        {
            phone: phone
        }
    );
}


export function generateCodeApi(lotteryId) {
    return ajaxJson.put(
        `merchants/admin/${getMerchantId()}/lotteries/generate_codes`,
        {
            lottery_uid: lotteryId
        }
    );
}

export function getLotteryApi(lotteryId) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/lottery/${lotteryId}/`)
        .then(res => {
            const data = res.data;
            return {
                id: data["uid"],
                title: data["title"],
                dateTime: data["lottery_time"],
                winnerCount: data["winner_count"],
                startCode: data["code_start"],
                state: data["status"],
                image: data["image"],
                campaign: {
                    label:
                        (data["campaign"] && data["campaign"]["title"]) || "",
                    value: (data["campaign"] && data["campaign"]["uid"]) || ""
                }
            };
        });
}

export function getRewardsApi(lotteryId) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/lotteries/rewards`, {
            params: {
                lottery_uid: lotteryId
            }
        })
        .then(res => {
            if (!res.data) {
                return [];
            }
            return res.data.map(item => {
                return {
                    id: item["uid"],
                    index: item["index"] + 1,
                    reward: item["reward"]
                };
            });
        });
}

export function setRewardsApi(lotteryId, index, reward) {
    return ajaxJson
        .post(`merchants/admin/${getMerchantId()}/lotteries/rewards`, {
            lottery_uid: lotteryId,
            reward: reward,
            index: index - 1
        })
        .then(res => {
            if (!res.data) {
                return [];
            }
            return res.data.map(item => {
                return {
                    id: item["uid"],
                    reward: item["reward"],
                    index: item["index"] + 1
                };
            });
        });
}

export function setWinnerCode(lotteryId, index, code) {
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/lotteries/${lotteryId}/winners/`,
            {
                reward_index: index,
                winner_code: code
            }
        )
        .then(res => {
            return res.data;
        });
}

export function getWinnersApi(lotteryId) {
    return ajaxJson
        .get(
            `merchants/admin/${getMerchantId()}/lotteries/${lotteryId}/winners/`
        )
        .then(res => {
            return (
                res.data &&
                Array.isArray(res.data) &&
                res.data.map(item => {
                    const firstName =
                        item["user"] && item["user"]["first_name"];
                    const lastName = item["user"] && item["user"]["last_name"];
                    let fullName = firstName + " " + lastName;
                    return {
                        index: item["index"],
                        fullName: fullName,
                        phone: item["user"] && item["user"]["phone"],
                        code: item["code"],
                        reward: item['reward']
                    };
                })
            );
        });
}

export function getConditionCategories() {
    return ajaxJson.get(`fixtures/condition_categories`).then(res => {
        return res.data.map(item => {
            return {
                id: item["uid"],
                title: item["name"],
                parent: item["parent_uid"]
            };
        });
    });
}

export function getConditionEffectAndCategories() {
    return ajaxJson.get(`fixtures/condition_effect_categories`).then(res => {
        return {
            conditions: res.data["condition_categories"].map(item => {
                return {
                    title: item["name"],
                    parent: item["parent_uid"],
                    id: item["uid"],
                    items: item["items"]
                };
            }),
            effects: res.data["effect_categories"].map(item => {
                return {
                    title: item["name"],
                    parent: item["parent_uid"],
                    id: item["uid"],
                    items: item["items"]
                };
            })
        };
    });
}

export function getMerchantCardsApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/credit_cards`, {
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getTicketsApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/ticketing/tickets/`, {
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getOrganizationsApi(options = {}) {
    const {page = 1} = options;
    return OrganizationAjaxJson.get(`admin/merchants/organizations`, {
            headers: Headers,
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getEmployeesApi(organizationId, options = {}) {
    const {page = 1} = options;
    return OrganizationAjaxJson.get(`admin/organizations/${organizationId}/employees`, {
            headers: Headers,
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function createTicket(ticketData) {
    console.log(ticketData.selectedSubject)
    let formData = new FormData();
    formData.append("summary", ticketData.name);
    formData.append("description", ticketData.description);
    if (ticketData.file) {
        formData.append("attachment", ticketData.file);
    }
    formData.append("priority", ticketData.priority);
    formData.append("subject", ticketData.selectedSubject.id);
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/ticketing/tickets/`, formData)
        .then(res => {
            return res.data;
        })
}

export function createMerchantCard(merchantCardData) {
    let formData = new FormData();
    formData.append("name", merchantCardData.title);
    formData.append("des", merchantCardData.description);
    formData.append("price_original", merchantCardData.creditAmount);
    formData.append("price", merchantCardData.purchaseAmount);
    formData.append("start_date", merchantCardData.enableAt);
    formData.append("stock", merchantCardData.numberOfCards);
    if (merchantCardData.image) {
        formData.append("image", merchantCardData.image);
    }
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/credit_cards`, formData)
        .then(res => {
            return res.data;
        });
}


export function createProduct(productData) {
    let formData = new FormData();
    formData.append("name", productData.name);
    formData.append("des", productData.description);
    formData.append("price_original", productData.priceOriginal);
    formData.append("price", productData.price);
    formData.append("is_active", productData.isActive);
    formData.append("client_id", productData.clientId);
    formData.append("is_infinite", productData.infiniteSell);

    // if(productData.mainCategory){
    //     formData.append("category", productData.mainCategory);
    // }
    if (productData.category_level_three) {
        formData.append("category", productData.category_level_three);
    } else if (productData.category_level_two) {
        formData.append("category", productData.category_level_two);
    } else {
        formData.append("category", productData.category_level_one);
    }
    for (var i = 0; i < productData.otherCategories.length; i++) {
        formData.append(`categories`, productData.otherCategories[i]);
    }

    if (productData.category_level_one) {
        formData.append("category_level_one", productData.category_level_one);
    }

    if (productData.category_level_two) {
        formData.append("category_level_two", productData.category_level_two);
    }
    // formData.append("category_level_two", productData.category_level_two);

    if (productData.category_level_three) {
        formData.append("category_level_three", productData.category_level_three);
    }
    // formData.append("category_level_three", productData.category_level_three);

    formData.append("barcode", productData.barcode);
    formData.append("expire_date", productData.expire_date);
    formData.append("is_synchronizable", productData.sync);
    formData.append("show_in_menu", productData.showInMenu);
    formData.append("stock", productData.stock);
    if (productData.file) {
        formData.append("image", productData.file);
    }
    if (productData.uploadedImages.length != 0) {
        for (var i = 0; i < productData.uploadedImages.length; i++) {
            formData.append(`media`, productData.uploadedImages[i]);
        }
    }
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/products`,
            formData
        )
        .then(res => {
            return res.data;
        });
}

export function updateProduct(productData, productUid) {
    let formData = new FormData();
    formData.append("name", productData.name);
    formData.append("des", productData.description);
    formData.append("price_original", productData.priceOriginal);
    formData.append("price", productData.price);
    formData.append("is_active", productData.isActive);
    formData.append("client_id", productData.clientId);
    formData.append("is_infinite", productData.infiniteSell);
    // if(productData.mainCategory){
    //     formData.append("category", productData.mainCategory);
    // }
    if (productData.category_level_three) {
        formData.append("category", productData.category_level_three);
    } else if (productData.category_level_two) {
        formData.append("category", productData.category_level_two);
    } else {
        formData.append("category", productData.category_level_one);
    }
    for (var i = 0; i < productData.otherCategories.length; i++) {
        formData.append(`categories`, productData.otherCategories[i]);
    }

    if (productData.category_level_one) {
        formData.append("category_level_one", productData.category_level_one);
    }

    if (productData.category_level_two) {
        formData.append("category_level_two", productData.category_level_two);
    } else {
        formData.append("category_level_two", '');
    }
    // formData.append("category_level_two", productData.category_level_two);

    if (productData.category_level_three) {
        formData.append("category_level_three", productData.category_level_three);
    } else {
        formData.append("category_level_three", '');
    }
    // formData.append("category_level_three", productData.category_level_three);

    formData.append("barcode", productData.barcode);
    formData.append("expire_date", productData.expire_date);
    formData.append("is_synchronizable", productData.sync);
    formData.append("show_in_menu", productData.showInMenu);
    formData.append("stock", productData.stock);
    if (productData.file) {
        formData.append("image", productData.file);
    }

    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${productUid}`,
            formData
        )
        .then(res => {
            return res.data;
        });
}


export function updatePatchProduct(obj, productId) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${productId}`, obj, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function updatePatchOrder(obj, productId) {
    return ajaxJson
        .patch(`merchants/admin/${getMerchantId()}/shop_orders/${productId}/`, obj, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}


export function createOrganization(organizationData) {
    let formData = new FormData();
    console.log(organizationData.name)
    formData.append("name", organizationData.name);
    formData.append("mobile", organizationData.mobile);
    formData.append("email", organizationData.email);
    formData.append("card_type", organizationData.cardType);
    formData.append("legal_number", organizationData.legalNumber);
    formData.append("initial_validity", organizationData.initialValidity);
    if (organizationData.image) {
        formData.append("image", organizationData.image);
    }
    if (organizationData.logo) {
        formData.append("logo", organizationData.logo);
    }
    let merchant_detail = getSelectedMerchantDetail()
    formData.append("merchant_name", merchant_detail.name);
    formData.append("merchant_mobile_number", auth.getUser().phoneNumber);
    formData.append("merchant_real_wallet", merchant_detail.wallet_id);
    formData.append("merchant_client_id", merchant_detail.payment_sdk_client_id);
    formData.append("acceptor", merchant_detail.acceptor);
    return OrganizationAjaxJson
        .post(`admin/merchants/organizations`, formData, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function uploadExcelFile(excelFile, organizationId) {
    let formData = new FormData();
    formData.append("file", excelFile);
    return OrganizationAjaxJson
        .post(`admin/organizations/${organizationId}/upload_excel_file`, formData, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function extractExcelFile(excelFile, organizationId) {
    let formData = new FormData();
    formData.append("file", excelFile);
    return OrganizationAjaxJson
        .post(`admin/organizations/${organizationId}/extract-excel-file-data`, formData, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function getOrganizationWalletChargesApi(organizationId, options = {}) {
    const {page = 1} = options;
    return OrganizationAjaxJson.get(`admin/organizations/${organizationId}/wallet-charges`, {
            headers: Headers,
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getOrganizationExcelFilesApi(organizationId, options = {}) {
    const {page = 1} = options;
    return OrganizationAjaxJson.get(`admin/organizations/${organizationId}/excel-files`, {
            headers: Headers,
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function getOrganizationDetailApi(organizationId) {
    return OrganizationAjaxJson
        .get(`admin/organizations/${organizationId}`, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function getCreditCardPurchasersApi(cardId, options = {}) {
    const {page = 1} = options;
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/credit_cards/${cardId}/users`, {
            params: {
                page: page
            }
        }
    ).then(res => {
        return res.data
    });
}

export function updateOrganization(organizationData, organizationId) {
    let formData = new FormData();
    formData.append("mobile", organizationData.mobile);
    formData.append("email", organizationData.email);
    if (organizationData.image instanceof File) {
        formData.append("image", organizationData.image);
    }
    if (organizationData.logo instanceof File) {
        formData.append("logo_image", organizationData.logo);
    }
    return OrganizationAjaxJson
        .put(`admin/organizations/${organizationId}/update`, formData, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}

export function getCreditCardDetail(cardId) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/credit_cards/${cardId}`)
        .then(res => {
            return res.data
        });
}

export function updateCreditCard(creditCardData, cardId) {
    let formData = new FormData();
    formData.append("name", creditCardData.name);
    formData.append("des", creditCardData.description);
    if (creditCardData.image instanceof File) {
        formData.append("image", creditCardData.image);
    }
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/credit_cards/${cardId}`, formData, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}


export function getUserInfo(userId) {
    return ajaxJson.get(`users/info/${userId}`)
        .then(res => {
            return res.data
        });
}

export function getReceiverInfo(topicId) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics/${topicId}`)
        .then(res => {
            return res.data
        });
}

export function getTopicsApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics`,
        {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data
        });
}

export function createUpdateTopicApi(topicId) {
    return ajaxJson.post(
        `merchant_admin/${getMerchantId()}/admin/topics`,
        {
            topic: topicId,
        })
        .then(res => {
            return res.data
        });
}


export function newGetChatMessagesApi(topicId, options = {}) {
    const {page = 1} = options;
    let userg = localStorage.getItem('user');
    let user = JSON.parse(userg)
    return axios.get(`https://api-test.digimaall.com/v1/merchant_admin/${getMerchantId()}/admin/topics/${topicId}/messages`,
        {
            headers: {
                "Authorization": `Bearer ${user.token}`
            },
            params: {
                page: page
            }
        })
        .then(res => {
            console.log("xxxxxxxxxxxxxxxxxxxxxxx .....................", res)
            return res.data
        });
}

export function getChatMessagesApi(topicId, options = {}) {
    const {page = 1} = options;
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics/${topicId}/messages`,
        {
            params: {
                page: page
            }
        })
        .then(res => {
            console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa .....................", res)
            return res.data
        });
}


export function getMerchantColors() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/merchant_colors`)
        .then(res => {
            return res.data
        });
}

export function getEmployeeTransactionsApi(
    organizationId, employeeId,
    wallet, options = {}
) {
    const {page = 1} = options;
    return OrganizationAjaxJson
        .get(`admin/organizations/${organizationId}/employees/${employeeId}/wallets/${wallet}/transactions`, {
            headers: Headers,
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getEmployeeDetailApi(
    organizationId, employeeId
) {
    return OrganizationAjaxJson
        .get(`admin/organizations/${organizationId}/employees/${employeeId}`, {
            headers: Headers
        })
        .then(res => {
            return res.data;
        });
}


export function getPostedOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    const {posted_orders = false} = options;

    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    posted_orders: true,
                    sort: 25
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    posted_orders: true,
                    sort: 25
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getDeliveredOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    const {picked_orders = false} = options;

    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    non_delivery_orders: true,
                    sort: 33
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    non_delivery_orders: true,
                    sort: 33
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getPickedOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    const {picked_orders = false} = options;

    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    picked_orders: true,
                    sort: 10
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    picked_orders: true,
                    sort: 10
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getAllOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    const {new_orders = false} = options;

    let par = {}

    switch (stFilter) {
        case 'all':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                all: true,
                sort: 3
            }
            break;
        case 'new':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                new_orders: true,
                sort: 3
            }
            break;
        case 'picked':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                picked_orders: true,
                sort: 3
            }
            break;
        case 'cashed':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                new_orders: true,
                sort: 3
            }
            break;
        case 'send_peyk':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                posted_orders: true,
                sort: 3
            }
            break;
        case 'send_none':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                non_delivery_orders: true,
                sort: 3
            }
            break;
        case 'cancel':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                canceled: true,
                sort: 3
            }
            break;
        case 'debt':
            par = {
                page: page,
                uid: searchText,
                finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                debt: true,
                sort: 3
            }
            break;
    }


    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: par
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: par
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getNewOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    const {new_orders = false} = options;

    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    new_orders: true,
                    sort: 3
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    // status: stFilter==="all"?null:stFilter,
                    new_orders: true,
                    sort: 3
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getOrdersApi(options = {}) {
    const {page = 1} = options;
    const {token = 'admin'} = options;
    const {merchantId = 'merchant'} = options;
    const {fromTime = ''} = options;
    const {toTime = ''} = options;
    const {searchText = ''} = options;
    const {statusFilter = ''} = options;
    const {stFilter = ''} = options;
    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    status: statusFilter
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders`, {
                params: {
                    page: page,
                    uid: searchText,
                    finalize_with_user_at_before: fromTime ? fromTime.toISOString() : '',
                    finalize_with_user_at_after: toTime ? toTime.toISOString() : '',
                    status: statusFilter
                }
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getProductsApi(categoryId, token, merchantId, page) {
    let params = {}
    if (categoryId) {
        params = {
            page: page,
            category__uid: categoryId,
            is_available: true
        }
    } else {
        params = {
            page: page,
            is_available: true
        }
    }
    if (token != 'admin' && merchantId != 'merchant') {
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders/products`, {
                params: params
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders/products`, {
                params: params
            })
            .then(res => {
                return {
                    totalPage: res.data["total_pages"],
                    count: res.data["count"],
                    results: res.data["results"]
                };
            });
    }
}


export function getOrderDetailApi(orderId, token, merchantId) {
    if (token != 'admin' && merchantId != 'merchant') {
        console.log(token)
        console.log()
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .get(`merchants/admin/${merchantId}/shop_orders/${orderId}/`, {})
            .then(res => {
                return res.data
            });
    } else {
        return ajaxJson
            .get(`merchants/admin/${getMerchantId()}/shop_orders/${orderId}/`, {})
            .then(res => {
                return res.data
            });
    }

}


export function addOrderItemApi(data, orderId, token, merchantId) {
    if (token != 'admin' && merchantId != 'merchant') {
        let formData = new FormData();
        formData.append("product_id", data.productId);
        formData.append("quantity", data.quantity);
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .post(`merchants/admin/${merchantId}/shop_orders/${orderId}/items/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res;
            });
    } else {
        let formData = new FormData();
        formData.append("product_id", data.productId);
        formData.append("quantity", data.quantity);
        return ajaxJson
            .post(`merchants/admin/${getMerchantId()}/shop_orders/${orderId}/items/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res;
            });
    }
}


export function decreaseOrderItemApi(data, orderId, token, merchantId) {
    if (token != 'admin' && merchantId != 'merchant') {
        let formData = new FormData();
        formData.append("product_id", data.productId);
        formData.append("quantity", data.quantity);
        const androidAuthHeaderReqInterceptor = [
            config => {
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .post(`merchants/admin/${merchantId}/shop_orders/${orderId}/items/change_quantity/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res.data;
            });
    } else {
        let formData = new FormData();
        formData.append("product_id", data.productId);
        formData.append("quantity", data.quantity);
        return ajaxJson
            .post(`merchants/admin/${getMerchantId()}/shop_orders/${orderId}/items/change_quantity/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res.data;
            });
    }
}

export function patchOrders(orderData, orderId) {


    try {
        return ajaxJson
            .patch(`merchants/admin/${getMerchantId()}/shop_orders/${orderId}/`, orderData)
            .then(res => {
                return res.data;
            });
    } catch (e) {
        console.log(e)
    }

}


export function updateOrders(orderData, orderId, token, merchantId) {
    if (token != 'admin' && merchantId != 'merchant') {
        let formData = new FormData();
        formData.append("status", orderData.status);
        const androidAuthHeaderReqInterceptor = [
            config => {
                if (auth.isLogin()) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                } else {
                    delete config.headers["Authorization"];
                }
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        ];
        androidAjaxJson.interceptors.request.use(...androidAuthHeaderReqInterceptor);
        return androidAjaxJson
            .patch(`merchants/admin/${merchantId}/shop_orders/${orderId}/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res.data;
            });
    } else {
        let formData = new FormData();
        formData.append("status", orderData.status);
        return ajaxJson
            .patch(`merchants/admin/${getMerchantId()}/shop_orders/${orderId}/`, formData, {
                headers: Headers
            })
            .then(res => {
                return res.data;
            });
    }
}

export function getMessagesApi(options = {}) {
    const {page = 1} = options;
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return {
                totalPage: res.data["total_pages"],
                count: res.data["count"],
                results: res.data["results"]
            };
        });
}


export function getMessageTemplateApi(options = {}) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/merchant-message-templates`, {})
        .then(res => {
            return res
        });
}


export function getMessageTemplateDetailApi(templateId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/merchant-message-templates/${templateId}`, {})
        .then(res => {
            return res
        });
}

export function getMessageDetailApi(messageId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}`, {})
        .then(res => {
            return res
        });
}

export function getTicketDetailApi(ticketId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/ticketing/tickets/${ticketId}/`, {})
        .then(res => {
            return res
        });
}

export function getTicketSubjectsApi() {
    return ajaxJson
        .get(`ticketing/subjects/`, {})
        .then(res => {
            return res
        });
}

export function getTicketCommentsApi(ticketId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/ticketing/tickets/${ticketId}/comments/`, {})
        .then(res => {
            return res
        });
}

export function getMessageUsersApi(messageId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}/users`, {})
        .then(res => {
            return res
        });
}

export function getPollParticipatedUsersApi(messageId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}/poll/users`, {})
        .then(res => {
            return res
        });
}


export function getMessageDetail(messageId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}`, {})
        .then(res => {
            return res
        });
}


export function createMessageApi(messageData) {
    let formData = new FormData();
    formData.append("title", messageData.title);
    formData.append("body", messageData.description);
    formData.append("is_special", messageData.isSpecial);
    formData.append("campaign", messageData.campaign);
    formData.append("message_type", messageData.message_type);
    if (messageData.smsTemplate) {
        formData.append("sms_template", messageData.smsTemplate);
    }
    if (messageData.link) {
        formData.append("link", messageData.link);
    }
    if (messageData.type) {
        formData.append("type", messageData.type);
    }
    if (messageData.file) {
        formData.append("file", messageData.file);
    }
    return ajaxJson
        // .post(`merchant_admin/${getMerchantId()}/admin/notifications`, formData)
        .post(`merchant_admin/${getMerchantId()}/admin/messages`, formData)
        .then(res => {
            return res.data;
        });
}


export function updateMessageApi(messageData, messageId) {
    let formData = new FormData();
    formData.append("title", messageData.title);
    formData.append("body", messageData.description);
    formData.append("is_special", messageData.isSpecial);
    formData.append("campaign", messageData.campaign);
    formData.append("message_type", messageData.message_type);
    if (messageData.smsTemplate) {
        formData.append("sms_template", messageData.smsTemplate);
    }
    if (messageData.link) {
        formData.append("link", messageData.link);
    }
    if (messageData.question) {
        formData.append("question", messageData.question);
    }
    if (messageData.items) {
        formData.append("items", messageData.items);
    }
    if (messageData.type) {
        formData.append("type", messageData.type);
    }
    if (messageData.finalPollType) {
        formData.append("type", messageData.finalPollType);
    }
    if (messageData.file) {
        formData.append("file", messageData.file);
    }
    return ajaxJson
        // .post(`merchant_admin/${getMerchantId()}/admin/notifications`, formData)
        .put(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}`, formData)
        .then(res => {
            return res.data;
        });
}

export function createPollApi(messageData) {
    console.log(messageData)
    let formData = new FormData();
    formData.append("title", messageData.title);
    formData.append("question", messageData.question);
    formData.append("is_special", messageData.isSpecial);
    formData.append("type", messageData.finalPollType);
    formData.append("campaign", messageData.campaign);
    formData.append("items", messageData.items);
    if (messageData.file) {
        formData.append("file", messageData.file);
    }
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/message-polls`, formData)
        .then(res => {
            return res.data;
        });
}

export function getMessageRulesApi(messageId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}/rules`, {})
        .then(res => {
            return res
        });
}


export function createMessageRuleApi(messageData, messageId) {
    console.log(messageData)
    let formData = new FormData();
    formData.append("title", messageData.title);
    formData.append("question", messageData.question);
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}/rules`, formData)
        .then(res => {
            return res.data;
        });
}


export function getRolesApi(options = {}) {
    const {rolesPage = 1} = options;
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/roles`, {
            params: {
                page: rolesPage
            }
        })
        .then(res => {
            return res.data
        });
}

export function getRoleUsersApi(options = {}) {
    const {usersPage = 1} = options;
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/user-roles`, {
            params: {
                page: usersPage
            }
        })
        .then(res => {
            return res.data
        });
}


export function deleteRoleApi(options = {}) {
    const {roleId = null} = options;
    return ajaxJson
        .delete(`merchant_admin/${getMerchantId()}/admin/roles/${roleId}`, {})
        .then(res => {
            return res.data
        });
}

export function deleteRoleUserApi(options = {}) {
    const {userId = null} = options;
    return ajaxJson
        .delete(`merchant_admin/${getMerchantId()}/admin/user-roles/${userId}`, {})
        .then(res => {
            return res.data
        });
}


export function getUserByPhoneApi(options = {}) {
    const {phoneNumber = 0} = options;
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/user-by-phone`, {
            params: {
                phone: phoneNumber
            }
        })
        .then(res => {
            return res.data
        });
}

export function getCouponDetailApi(code) {
    return ajaxJson
        .get(`coupons/code/${code}/public`)
        .then(res => {
            return res.data
        });
}

export function CheckCouponApi(data) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/coupon/check`, data)
        .then(res => {
            return res.data
        });
}

export function getUserByPhonePostApi(options = {}) {
    const {phoneNumber = 0} = options;
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customers/by-phone`, {phone: phoneNumber})
        .then(res => {
            return res.data
        });
}

export function miareApi(orderId) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/order-picker/orders/${orderId}/set_external_courier`, {})
        .then(res => {
            return res.data
        });
}

export function getAloCreditApi() {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/order-picker/get-alopeyk-credit`, {})
        .then(res => {
            return res.data
        });
}

export function getAloEstimateApi(orderId) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/order-picker/orders/${orderId}/estimate-courier-price`, {})
        .then(res => {
            return res.data
        });
}


export function cancelOrderApi(orderId) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/order-picker/orders/${orderId}/cancel_picking_order`, {})
        .then(res => {
            return res.data
        });
}


export function getCustomerExcelApi() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/customers/export`)
        .then(res => {
            return res.data
        });
}

export function getInvoicesExcelApi() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/invoice_export`)
        .then(res => {
            return res.data
        });
}

export function registerCustomerApi(user = {}) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/customers`, user)
        .then(res => {
            return res.data
        });
}

export function UpdateUserApi(user = {}, cuid) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/customers/${cuid}`, user)
        .then(res => {
            return res.data
        });
}

export function updateRoleUserApi(options = {}) {
    const {userId = null} = options;
    const {isActive = null} = options;
    return ajaxJson
        .patch(`merchant_admin/${getMerchantId()}/admin/user-roles/${userId}`, {
            active: isActive
        })
        .then(res => {
            return res.data
        });
}

export function completeUpdateRoleUserApi(options = {}) {
    const {userRoleId = null} = options;
    const {userId = null} = options;
    const {roleId = null} = options;

    return ajaxJson
        .patch(`merchant_admin/${getMerchantId()}/admin/user-roles/${userRoleId}`, {
            user: userId,
            role: roleId
        })
        .then(res => {
            return res.data
        });
}


export function createRoleUserApi(options = {}) {
    const {userId = null} = options;
    const {roleId = null} = options;
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/user-roles`, {
            user: userId,
            role: roleId
        })
        .then(res => {
            return res.data
        });
}


export function updateRoleApi(options = {}) {
    const {roleId = null} = options;
    const {isActive = null} = options;

    return ajaxJson
        .patch(`merchant_admin/${getMerchantId()}/admin/roles/${roleId}`, {
            active: isActive,
        })
        .then(res => {
            return res.data
        });
}


export function completeUpdateRoleApi(options = {}) {
    const {roleEdit = null} = options;
    const {selectedPermissions = null} = options;
    const {roleTitle = null} = options;

    return ajaxJson
        .patch(`merchant_admin/${getMerchantId()}/admin/roles/${roleEdit}`, {
            permissions: selectedPermissions,
            title: roleTitle
        })
        .then(res => {
            return res.data
        });
}


export function getPermissionCategoriesApi() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/permission-categories`, {})
        .then(res => {
            return res.data
        });
}


export function getRoleTemplatesApi() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/role-templates`, {})
        .then(res => {
            return res.data
        });
}

export function getReferralStatus() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/referrals`, {})
        .then(res => {
            return res.data
        });
}

export function setReferralStatus(status) {
    return ajaxJson
        .put(`merchants/admin/${getMerchantId()}/referrals`, {
            "has_referral": status
        })
        .then(res => {
            return res.data
        });
}


export function createRoleApi(options = {}) {
    const {roleTitle = ''} = options;
    const {selectedPermissions = []} = options;
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/roles`, {
            title: roleTitle,
            permissions: selectedPermissions
        })
        .then(res => {
            return res.data
        });
}


export function getBulkMessage() {
    return ajaxJson
        .post(
            `merchant_admin/${getMerchantId()}/admin/messages/campaign`,
        )
        .then(res => {
            return res.data
        });
}

export function getCustomerTagCampaignApi(st, en) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customer-tags/campaign`, {
            start_date: st,
            end_date: en
        })
        .then(res => {
            return res.data
        });
}


export function getTagCampaign() {
    return ajaxJson
        .post(
            `merchant_admin/${getMerchantId()}/admin/tag/campaign`,
        )
        .then(res => {
            return res.data
        });
}


export function saveFileForEmqxApi(data, topic_id) {
    let formData = new FormData();
    console.log(data)
    formData.append("type", data.type);
    if (data.file) {
        formData.append("file", data.file);
    }
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/topics/${topic_id}/files`, formData)
        .then(res => {
            return res.data;
        });
}


export function createMessageRule(conditions_data, effects, campaignId, rule_data) {
    console.log(rule_data)
    const conditions = conditions_data.map(i => i.id);
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/campaign/${campaignId}/rules`,
            {
                // title: rule.title,
                conditions: conditions,
                effects: [effects],
                ...rule_data

            }
        )
        .then(res => {
            return {
                id: res.data["uid"],
                conditions: res.data["conditions"],
                effects: res.data["effects"],
                title: res.data["title"],
                isUsabilityEqualToOne: res.data["is_usability_equal_to_one"],
                createAt: res.data["created"]
            };
        });
}


export function getCompleteSellReportApi(time = null) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/complete-sell-reports`, {
            params: {
                time: time
            }
        })
        .then(res => {
            return res.data
        });
}


export function getSellDaysReportApi(startDate = null, endDate = null) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/days-sell-reports`, {
            params: {
                paid_at_after: startDate && startDate.toISOString(),
                paid_at_before: endDate && endDate.toISOString()
            }
        })
        .then(res => {
            return res.data
        });
}


export function getMessageMonthCountReportApi(type) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/months-message-reports`, {
            params: {
                type: type || null,
            }
        })
        .then(res => {
            return res.data
        });
}


export function getInvoiceVisitMonthCountReportApi() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/months-invoice-token-visit-reports`, {})
        .then(res => {
            return res.data
        });
}

export function getNotifPermissionsMonthCountReportApi(hasToken) {
    if (hasToken !== '') {
        var params = {
            params: {
                has_fcm_token: hasToken
            }
        }
    } else {
        var params = {}
    }

    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/merchant-customers-reports`, params)
        .then(res => {
            return res.data
        });
}

export function getCompleteCustomerReportApi(time = null) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/complete-customer-reports`, {
            params: {
                time: time
            }
        })
        .then(res => {
            return res.data
        });
}

export function getBestCustomersApi(startDate = null, endDate = null, ordering = null) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/best-customers`, {
            params: {
                invoice_paid_at_after: startDate && startDate.toISOString(),
                invoice_paid_at_before: endDate && endDate.toISOString(),
                ordering: ordering
            }
        })
        .then(res => {
            return res.data
        });
}

export function getSellReportApi() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/sell-reports`, {})
        .then(res => {
            return res.data
        });
}


export function createTagRule(conditions_data, effects, campaignId, rule_data) {
    const conditions = conditions_data.map(i => i.id);
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/campaign/${campaignId}/rules`,
            {
                // title: rule.title,
                conditions: conditions,
                effects: [effects],
                ...rule_data

            }
        )
        .then(res => {
            return {
                id: res.data["uid"],
                conditions: res.data["conditions"],
                effects: res.data["effects"],
                title: res.data["title"],
                isUsabilityEqualToOne: res.data["is_usability_equal_to_one"],
                createAt: res.data["created"]
            };
        });
}


export function createCustomerTagApi(data) {
    return ajaxJson
        .post(
            `merchant_admin/${getMerchantId()}/admin/customer-tags`,
            {
                title: data.title,
                description: data.description || '',
                campaign: data.campaign,
            }
        )
        .then(res => {
            return res.data
        });
}


export function createTagApi(data) {
    return ajaxJson
        .post(
            `merchant_admin/${getMerchantId()}/admin/tag`,
            {
                title: data.title,
                description: data.description || '',
                campaign: data.campaign,
            }
        )
        .then(res => {
            return res.data
        });
}


export function updateTagApi(data, tagId) {
    return ajaxJson
        .put(
            `merchant_admin/${getMerchantId()}/admin/tag/${tagId}`,
            {
                title: data.title,
                description: data.description || '',
            }
        )
        .then(res => {
            return res.data
        });
}


export function getCustomerTagsApi(page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/customer-tags`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data
        });
}


export function getTagsApi(page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/tag`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data
        });
}


export function getCustomerTagDetailApi(tagId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tagId}`, {})
        .then(res => {
            return res.data
        });
}


export function getTagDetailApi(tagId) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/tag/${tagId}`, {})
        .then(res => {
            return res.data
        });
}

export function getMerchantMessagesUser(messageId, page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/messages/${messageId}/users`, {
            params: {page: page}
        })
        .then(res => {
            return res.data
        });
}

export function getTagUsersApi(tagTitle, id) {
    console.log("Dio : ", tagTitle, id)
    return ajaxJson
        //.get(`merchants/admin/${getMerchantId()}/users`, {
        .get(`merchant_admin/${getMerchantId()}/admin/tag/${id}/users`)
        .then(res => {
            return res.data
        });

}

export function getReportBarSellCount(params) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/categories_bar_sell_count_report?${params}`).then(res => {
        return res.data
    });
}

export function getReportBarSellAmount(params) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/categories_bar_sell_amount_report?${params}`).then(res => {
        return res.data
    });
}

export function getReportAreaSellCount(params) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/categories_area_sell_amount_report?${params}`).then(res => {
        return res.data
    });
}

export function getReportAreaMerchants(params) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/merchants_area_sell_amount_report?${params}`).then(res => {
        return res.data
    });
}

export function getReportSunbrust(params) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/categories_pie_sell_amount_report?${params}`).then(res => {
        return res.data
    });
}


export function createCouponCategoryAPI(title, description) {
    return ajaxJson
        .post(
            `merchant_admin/${getMerchantId()}/admin/coupon_categories`,
            {
                title: title,
                description: description
            }
        )
        .then(res => {
            return res.data;
        });
}


export function getCouponCategoriesAPI(page, searchText = '') {
    let params = {
        page: page,
        search: searchText,
    }
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/coupon_categories`,
            {
                params: params
            }
        )
        .then(res => {
            return res.data;
        });
}

export function deleteCouponCategoryApi(categoryId) {
    return ajaxJson.delete(
        `merchant_admin/${getMerchantId()}/admin/coupon_categories/${categoryId}`
    );
}


export function getCouponCategoryApi(categoryId) {
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/coupon_categories/${categoryId}`,
        )
        .then(res => {
            return res.data;
        });
}

export function updateCouponCategoryApi(data, categoryId) {
    return ajaxJson
        .put(
            `merchant_admin/${getMerchantId()}/admin/coupon_categories/${categoryId}`,
            {
                title: data.title,
                description: data.description || '',
            }
        )
        .then(res => {
            return res.data
        });
}


export function uploadProductImageApi(image, productId) {
    let formData = new FormData();
    if (productId != 'add') {
        formData.append("product", productId);
    }
    formData.append("type", 'image');
    image && formData.set("file", image);
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/product-media`, formData)
        .then(res => res.data);
}

export function deleteProductImageApi(imageId) {
    return ajaxJson
        .delete(`merchant_admin/${getMerchantId()}/admin/product-media/${imageId}`)
        .then(res => res.data);
}


export function getCustomersApi(options = {}) {
    const {
        page,
        sort,
        search,
        fullName,
        created,
        hasToken,
        membership_type
    } = options;
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/customers`,
            {
                params: {
                    page: page,
                    membership_type: membership_type,
                    full_name: fullName,
                    search: search,
                    created: created && created.toISOString(),
                    has_fcm_token: hasToken,
                    order: sort ? sort : "-created"
                }
            }
        )
        .then(res => {
            return res.data
        });
}


export function createCustomerAPI(data) {
    return ajaxJson
        .post(
            `merchants/admin/${getMerchantId()}/customers`,
            {
                'user': data,
                'merchant': getMerchantId()
            }
        )
        .then(res => {
            return res.data;
        });
}


export function merchantGroupDetailApi(merchantGroupId) {
    return ajaxJson.get(
        `merchant_admin/${getMerchantId()}/admin/merchant_groups/${merchantGroupId}`
    ).then(res => {
        return res.data
    });
}

export function getRewardItems() {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/select2_reward_items`)
        .then(res => {
            return res.data;
        });
}


export function createReward(data) {
    let formData = new FormData();
    if (data.image instanceof File) {
        formData.set("image", data.image);
    }

    if (data.file instanceof File) {
        formData.set("file", data.file);
    }

    if (data.award_type === "campaign_lottery_point") {
        formData.set("campaign_points", data.campaign_points);
        formData.set("related_campaign", JSON.stringify(data.related_campaign));
    }

    formData.set("award_type", data.award_type);
    formData.set("title", data.title);
    formData.set("description", data.description);
    formData.set("required_points", data.required_points);
    formData.set("organization", data.organization.value);


    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/awards`, formData)
        .then(res => {
            return res.data;
        });
}


export function editAeward(data, id) {
    let formData = new FormData();
    if (data.image instanceof File) {
        formData.set("image", data.image);
    }

    if (data.file instanceof File) {
        formData.set("file", data.file);
    }

    if (data.award_type === "campaign_lottery_point") {
        formData.set("campaign_points", data.campaign_points);
        formData.set("related_campaign", JSON.stringify(data.related_campaign));
    }

    formData.set("award_type", data.award_type);
    formData.set("title", data.title);
    formData.set("description", data.description);
    formData.set("required_points", data.required_points);
    formData.set("organization", data.organization.value ? data.organization.value : data.organization.uid);


    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/awards/${id}`, formData)
        .then(res => {
            return res.data;
        });
}


export function getAwardOrganization() {
    return ajaxJson
        .get(`/award/organizations`)
        .then(res => {
            return res.data;
        });
}

export function createAwardOrganization(name) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/awards/organizations`, {name: name})
        .then(res => {
            return res.data;
        });
}


export function ActiveAwardApi(id) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/awards/${id}/activate`)
        .then(res => {
            return res.data;
        });
}

export function deActiveAwardApi(id) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/awards/${id}/deactivate`)
        .then(res => {
            return res.data;
        });
}

export function deleteAwardCode(awardId, codeId) {
    return ajaxJson
        .delete(`/award/${awardId}/codes/${codeId}`)
        .then(res => {
            return res.data;
        });
}

export function deleteAwardAllCode(awardId) {
    return ajaxJson
        .delete(`/award/${awardId}/codes`)
        .then(res => {
            return res.data;
        });
}


export function getAwardDetailApi(id) {
    return ajaxJson
        .get(`/award/${id}`)
        .then(res => {
            return res.data;
        });
}


export function getAwardCodeApi(id, page = 1) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/awards/${id}/items`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getAwards(page = 1) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/awards`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getTemplate(page = 1, catId = null) {
    return ajaxJson
        .get(`/campaigns/${getMerchantId()}/campaign_templates`, {
            params: {
                page: page,
                page_size: 500,
                category__uid: catId
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getTemplateV2(page = 1, catId = null) {
    return ajaxJson
        .get(`/campaigns/${getMerchantId()}/campaign_templates/v2`, {
            params: {
                page: page,
                page_size: 500,
                category__uid: catId
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getTemplatesMerchants(page = 1, catId = null) {
    return ajaxJson
        .get(`/campaigns/${getMerchantId()}/merchant_campaign_templates`, {
            params: {
                page: page,
                page_size: 500,
                category__uid: catId
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getDetailTemplate(id) {
    return ajaxJson
        .get(`/campaigns/${getMerchantId()}/campaign_template/${id}`)
        .then(res => {
            return res.data;
        });
}


export function getTemplateCategories(page = 1) {
    return ajaxJson
        .get(`/campaigns/${getMerchantId()}/campaign_template_categories`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}


export function templateRequest_api(templateId, start, end) {
    console.log(templateId);
    console.log(start.toISOString());
    console.log(end.toISOString());
    return ajaxJson.post(`campaigns/${getMerchantId()}/template_corresponding`, {
        template_uid: templateId,
        start_date: start.toISOString(),
        end_date: end.toISOString()
    })
        .then(res => {
            return res.data
        });
}


export function templateCustomeRequest_api(templateId, description) {
    console.log(templateId);
    return ajaxJson.post(`ticketing/${getMerchantId()}/campaign_tickets`, {
        template: templateId,
        description: description
    })
        .then(res => {
            return res.data
        });
}

export function getTickets_api(page) {
    return ajaxJson.get(`ticketing/${getMerchantId()}/campaign_tickets`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}

export function payRollback_api(id) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/order-picker/rollback-invoices/${id}`, {"state": "success_to_pay"})
        .then(res => {
            return res.data
        });
}


export function updateRollback_api(id, obj) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/order-picker/rollback-invoices/${id}`, obj)
        .then(res => {
            return res.data
        });
}


// https://api-test.digimaall.com/v1/merchant_admin/PUbhbMBVJr/order-picker/rollback-invoices/GRQoePEeRC

export function getRequests_api(page) {

    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/prescriptions`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}


export function getMeds_api(page) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/med-orders`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}


export function getRollback_api(page) {
    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/order-picker/rollback-invoices`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}


export function getCommentsList_api(ticketId, page = 1) {
    return ajaxJson.get(`ticketing/${getMerchantId()}/${ticketId}/campaign_ticket_comments`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}

export function getRequestCommentsList_api(ticketId, page = 1) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/prescription_comments/${ticketId}`, {
        params: {
            page: page
        }
    })
        .then(res => {
            return res.data
        });
}

export function sendComments_api(ticketId, parent_uid, comment) {
    console.log(ticketId);
    console.log(parent_uid);
    console.log(comment);

    return ajaxJson.post(`ticketing/${getMerchantId()}/${ticketId}/campaign_ticket_comments`, {
        parent_uid: parent_uid,
        comment: comment
    })
        .then(res => {
            return res.data
        });
}


export function sendRequestComments_api(ticketId, parent_uid, comment) {
    console.log(ticketId);
    console.log(parent_uid);
    console.log(comment);

    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/prescription_comments/${ticketId}`, {
        parent_uid: parent_uid,
        comment: comment
    })
        .then(res => {
            return res.data
        });
}


export function activeToggle_api(permission, id) {
    const mallId = localStorage.getItem("mall")
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/customers/${id}`, {
        buy_permission: permission
    })
        .then(res => {
            return res.data
        });
}


export function getCustomersTApi(page, tag, search, fullName, created, hasToken) {
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/customers`,
            {
                params: {
                    page: page,
                    tag_uid: tag,
                    search: search,
                    full_name: fullName,
                    created: created && created.toISOString(),
                    has_fcm_token: hasToken
                }
            }
        )
        .then(res => {
            return res.data
        });
}


//
// export function getCustomersApi(options = {}) {
//     const {
//         page,
//         fullName,
//         created,
//         hasToken,
//     } = options;
//     return ajaxJson
//         .get(
//             `merchant_admin/${getMerchantId()}/admin/customers`,
//             {
//                 params: {
//                     page: page,
//                     full_name: fullName,
//                     created: created && created.toISOString(),
//                     has_fcm_token: hasToken
//                 }
//             }
//         )
//         .then(res => {
//             return res.data
//         });
// }


export function getNewCustomersApi(page, searchIn = null, search = null, created, hasToken) {
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/customers`,
            {
                params: {
                    page: page,
                    search_in: searchIn,
                    search: search,
                    created: created && created.toISOString(),
                    has_fcm_token: hasToken
                }
            }
        )
        .then(res => {
            return res.data
        });
}


export function assignCustomerToTagAPI(tagId, customerId) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tagId}/assign`, {
            customer_uid: customerId
        })
        .then(res => {
            return res.data;
        });
}

export function UnAssignCustomerToTagAPI(tagId, customerId) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tagId}/remove`, {
            customer_uid: customerId
        })
        .then(res => {
            return res.data;
        });
}

export function UnAssignAllCustomerToTagAPI(tagId) {
    return ajaxJson
        .patch(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tagId}/remove`)
        .then(res => {
            return res.data;
        });
}


export function createCustomerTagAPI(data) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customer-tags`, data)
        .then(res => {
            return res.data;
        });
}

export function editCustomerTagAPI(data, id) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/customer-tags/${id}`, data)
        .then(res => {
            return res.data;
        });
}

export function deleteCustomerTagAPI(id) {
    return ajaxJson
        .delete(`merchant_admin/${getMerchantId()}/admin/customer-tags/${id}`)
        .then(res => {
            return res.data;
        });
}

export function getCustomerTagsAPI(page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/customer-tags`, {
            params: {
                page: page
            }
        })
        .then(res => {
            return res.data;
        });
}

export function getCustomerTagWithIdAPI(id) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/customer-tags/${id}`)
        .then(res => {
            return res.data;
        });
}


// export function createCustomerAPI(data) {
//     return ajaxJson
//         .post(
//             `merchants/admin/${getMerchantId()}/customers`,
//             {
//                 'user': data,
//                 'merchant': getMerchantId()
//             }
//         )
//         .then(res => {
//             return res.data;
//         });
// }


// export function merchantGroupDetailApi(merchantGroupId) {
//     return ajaxJson.get(
//         `merchant_admin/${getMerchantId()}/admin/merchant_groups/${merchantGroupId}`
//     ).then(res => {
//         return res.data
//     });
// }


export function merchantExcelFileApi(file, tagId) {
    let formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tagId}/bulk-assign`, formData)
        .then(res => {
            return res.data;
        });
}


export function getProApi(page = 1, search = "", cat = "") {
    return ajaxJson
        .get(
            `merchant_admin/${getMerchantId()}/admin/products`,
            {
                params: {
                    page: page,
                    search: search,
                    category_level_one__uid: cat === 0 ? null : cat
                }
            }
        )
        .then(res => {
            return res.data
        });
}


export function merchantSendReferralApi(obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/referrals`, obj)
        .then(res => {
            return res.data;
        });
}


export function getMerchantsReferralListApi() {
    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/referrals/available_campaigns`).then(res => {
        return res.data;
    });
}


export function couponExportExcelApi() {
    return ajaxJson.get(`/merchants/admin/${getMerchantId()}/coupon_export`).then(res => {
        return res.data;
    });
}


export function deleteUnusedCampaignApi(campaignId) {
    return ajaxJson.delete(
        `merchant_admin/${getMerchantId()}/admin/messages/campaign/${campaignId}/delete`
    );
}

//Polls


export function getPollOneReport_api(pollId) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/poll_results/${pollId}`).then(res => {
        return res.data;
    });
}

export function getPollResultReport_api(pollId) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/poll_results/${pollId}/report`).then(res => {
        return res.data;
    });
}

export function getTopicCount_api(topic) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics/${topic}/unseen_count`).then(res => {
        // return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics/total_unseen`,{
        //     params:{
        //         topic:topic
        //     }
    }).then(res => {
        return res.data;
    });
}

export function getUnSeenMessage_api(topic) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/topics/total_unseen`).then(res => {
        return res.data;
    });
}

export function approvePrescription_api(obj) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/orders`, obj).then(res => {
        return res.data;
    });
}

export function approveMed_api(id, obj) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/med-orders/${id}`, obj).then(res => {
        return res.data;
    });
}

export function rejectMed_api(id, desc = "") {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/med-orders/${id}`, {
        status: 5,
        description: desc
    }).then(res => {
        return res.data;
    });
}

export function medChangeStatus_api(id, status) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/med-orders/${id}`, {
        status: status,
    }).then(res => {
        return res.data;
    });
}

export function getCourierList_api() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/merchant_couriers`).then(res => {
        return res.data;
    });
}

export function createCourier_api(data) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/merchant_couriers`, data).then(res => {
        return res.data;
    });
}

export function updateCourier_api(data, id) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}`, data).then(res => {
        return res.data;
    });
}

export function changeStatusOfCourier_api(data, id) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}`, data).then(res => {
        return res.data;
    });
}

export function deleteCourier_api(id) {
    return ajaxJson.delete(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}`).then(res => {
        return res.data;
    });
}

export function createCourierInterval_api(data, id) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}/intervals`, data).then(res => {
        return res.data;
    });
}

export function getCourierInterval_api(id) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}/intervals`).then(res => {
        return res.data;
    });
}

export function editCourierInterval_api(data, id) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${id}/intervals`, data).then(res => {
        return res.data;
    });
}


export function getMonthSell_api(paid_after, paid_before, one = null, two = null, three = null) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/months_invoice_reports`, {
        params: {
            paid_after: paid_after,
            paid_before: paid_before,
            category_level_one: one,
            category_level_two: two,
            category_level_three: three,
        }
    }).then(res => {
        return res.data;
    });
}

export function deleteCustomer_api(id) {
    return ajaxJson
        .delete(`merchant_admin/${getMerchantId()}/admin/customers/${id}`)
        .then(res => {
            return res.data
        });
}

export function editCustomer_api(id, obj) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/customers/${id}`, obj)
        .then(res => {
            return res.data
        });
}

export function incQuantityProduct_api(id, obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/order-picker/orders/${id}/items/change_quantity/`, obj)
        .then(res => {
            return res.data
        });
}

export function bulkAddProduct_api(id, obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/order-picker/orders/${id}/items/bulk_add`, obj)
        .then(res => {
            return res.data
        });
}

export function picking_done_api(id, obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/order-picker/orders/${id}/picking/done`, obj)
        .then(res => {
            return res.data
        });
}


export function finalCashier_api(id) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/order-picker/orders/${id}/finalize`)
        .then(res => {
            return res.data
        });
}

export function delivered_send_api(id) {
    return ajaxJson
        .patch(`merchants/admin/${getMerchantId()}/shop_orders/${id}/`, {status: 25})
        .then(res => {
            return res.data
        });
}

export function delivered_api(id) {
    return ajaxJson
        .patch(`merchants/admin/${getMerchantId()}/shop_orders/${id}/`, {status: 34})
        .then(res => {
            return res.data
        });
}

export function getMerchantCost_api() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/merchant-costs/`)
        .then(res => {
            return res.data
        });
}

export function setMerchantCost_api(obj) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/merchant-costs/`, obj)
        .then(res => {
            return res.data
        });
}

export function uploadProductCampaign_api(list, campId) {
    return ajaxJson
        .put(`/merchants/admin/${getMerchantId()}/product-campaign/${campId}/images/`, list, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}


export function uploadCustomersFileExcel_api(list) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/upload-bulk-customers-file/`, list, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}


export function sendTestMessage_api(list) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/test-send-messages/`, list, {timeout: 50000})
        .then(res => {
            return res.data
        });
}

export function createMessageTemplate_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/create-bulk-messages-template/`, obj, {timeout: 50000})
        .then(res => {
            return res.data
        });
}


export function editMessageTemplate_api(obj, id) {
    return ajaxJson
        .patch(`/merchant_admin/${getMerchantId()}/admin/bulk-messages/${id}/`, obj, {timeout: 50000})
        .then(res => {
            return res.data
        });
}


export function sendExcelFile_api(list) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/upload-products/`, list, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}

export function sendExcelObj_api(list) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/upload-products/`, list, {timeout: 50000})
        .then(res => {
            return res.data
        });
}

export function sendStockPriceExcelObj_api(list) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/update-product-stock/`, list)
        .then(res => {
            return res.data
        });
}


export function sendUnitExcelObj_api(list) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/update-units/`, list)
        .then(res => {
            return res.data
        });
}

export function sendDiscountExcelObj_api(list) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/update-discount/`, list)
        .then(res => {
            return res.data
        });
}


export function getExcelObj_api(page, status = null) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/products`, {
            params: {
                status: status,
                page_size: 10,
                page: page
            }
        })
        .then(res => {
            return res.data
        });
}

export function matchBarcode_api(list) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/search-barcode/`, list)
        .then(res => {
            return res
        });
}


export function chooseSearchedProduct_api(list) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/choose-product/`, list)
        .then(res => {
            return res
        });
}


export function searchMultiMatchBarcode_api(barcodes) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/base-merchant-products`, {
            params: {
                barcodes: barcodes
            }
        })
        .then(res => {
            return res.data
        });
}

export function searchBaseMerchantProduct_api(search) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/base-merchant-products`, {
            params: {
                search: search
            }
        })
        .then(res => {
            return res.data
        });
}

export function changeProductStatus_api(status, pId) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${pId}`, {
            status: status
        })
        .then(res => {
            return res
        });
}


export function getProvinces_api() {
    return ajaxJson.get(`fixtures/regions?type=0`).then(res => {
        return res.data;
    });
}

export function sendMerchantInfo_api(data) {
    return ajaxJson.patch(`merchant_admin/${getMerchantId()}/admin/`, data).then(res => {
        return res.data;
    });
}

export function merchantInfo_api() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/`).then(res => {
        return res.data;
    });
}

export function getTags_api(search=null) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/product-tags/select2`,{
        params: {
            search: search
        }
    }).then(res => {
        return res.data;
    });
}

export function getproductTagsS2_api(search=null,ids = null) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/product-tags/select2`,{
        params: {
            search: search,
            ids: ids
        }
    }).then(res => {
        return res;
    });
}

export function getProductTags_api() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/product-tags/select2`).then(res => {
        return res;
    });
}


export function deleteTagFromAllProduct_api(obj) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/remove-products-tags/`, obj).then(res => {
        return res.data;
    });
}


export function tagOnProduct_api(data) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/update-product-tags/`, data).then(res => {
        return res.data;
    });
}

export function sendLicenseImage_api(file, deleteFlag) {
    return ajaxJson.put(`merchant_admin/${getMerchantId()}/admin/images?delete_video=${deleteFlag}`, file, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    });
}

export function getUploadStatus_api() {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/uploads-end/`, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    });
}

export function getCourierSchedule_api(scheduleUid) {
    return ajaxJson.get(`schedule/${scheduleUid}/admin`, {
        params: {
            merchant_uid: getMerchantId()
        }
    });
}

export function editCourierSchedule_api(scheduleUid, obj) {
    return ajaxJson.put(`schedule/${scheduleUid}/admin?merchant_uid=${getMerchantId()}`, obj);
}

export function SetScheduleForCourier_api(cId, obj) {
    return ajaxJson.post(`merchant_admin/${getMerchantId()}/admin/merchant_couriers/${cId}/schedule`, obj);
}


export function getCities_api(id) {
    return ajaxJson.get(`/fixtures/regions`, {
        params: {
            type: 1,
            state: id
        }
    }).then(res => {
        return res.data;
    });
}


//billing detail
export function getBillingDetail_api(pId, page) {

    let params = {
        page: page,
    }

    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/products/${pId}/update_logs`, {
        params: params,
        headers: {
            'content-type': 'multipart/form-data'
        }
    });
}


//product log

export function getProductLog_api(pId, page, changed_in, creator, field) {

    let params = {
        page: page,
    }

    if (changed_in !== "all")
        params['changed_in'] = changed_in

    if (creator !== "all")
        params['creator'] = creator

    if (field !== "all")
        params['field'] = field

    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/products/${pId}/update_logs`, {
        params: params,
        headers: {
            'content-type': 'multipart/form-data'
        }
    });
}

export function getOrderLog_api(order_uid, page) {

    let params = {
        page: page,
    }

    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/orders/${order_uid}/status_logs`, {
        params: params,
        headers: {
            'content-type': 'multipart/form-data'
        }
    });
}

//select2 api
export function getSelect2_api(url, search = null) {
    url = url.replace('{{merchant_uid}}', getMerchantId())
    return ajaxJson.get(url, {
        params: {
            search: search
        }
    });
}

export function getCustomerTag_api(search = null) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/customer-tags/select2`, {
        params: {
            search: search
        }
    });
}

//campaigns template api
export function getDiscountCampaignOption_brand_api(search = null, ids = null) {
    let url = `merchant_admin/${getMerchantId()}/admin/product-brands/select2`
    if (ids)
        url = url + "?ids=" + ids
    return ajaxJson.get(url, {
        params: {
            search: search
        }
    });
}

export function getDiscountCampaignOption_cat_api(search = null, ids = null) {
    let url = `merchant_admin/${getMerchantId()}/admin/product-categories/select2`
    if (ids)
        url = url + "?ids=" + ids
    return ajaxJson.get(url, {
        params: {
            search: search
        }
    });
}

export function getDiscountCampaignOption_product_api(search = null, ids = null) {
    let url = `merchant_admin/${getMerchantId()}/admin/products/select2`
    if (ids)
        url = url + "?ids=" + ids
    return ajaxJson.get(url, {
        params: {
            search: search
        }
    });
}


export function sendActiveCampaignFromTemp_api(obj) {
    // return ajaxJson.post(`campaigns/${getMerchantId()}/create_from_template`,obj);
    return ajaxJson.post(`campaigns/${getMerchantId()}/by_template`, obj);
}

export function editCampaignCreateByTemp_api(obj, id) {
    // return ajaxJson.post(`campaigns/${getMerchantId()}/create_from_template`,obj);
    return ajaxJson.put(`campaigns/${getMerchantId()}/by_template`, obj);
}

export function getCampaignV2_api() {
    return ajaxJson.get(`campaigns/${getMerchantId()}/by_template/v2`);
}

export function getSponsorApi() {
    return ajaxJson.get(`campaigns/${getMerchantId()}/sponsors`);
}

export function sendActiveCampaignFromTempV2_api(obj) {
    // return ajaxJson.post(`campaigns/${getMerchantId()}/create_from_template`,obj);
    return ajaxJson.post(`campaigns/${getMerchantId()}/by_template/v2`, obj);
}

export function editCampaignCreateByTempV2_api(obj, id) {
    // return ajaxJson.post(`campaigns/${getMerchantId()}/create_from_template`,obj);
    return ajaxJson.put(`campaigns/${getMerchantId()}/by_template/v2`, obj);
}


export function sendActiveFestivalFromTemp_api(obj) {
    return ajaxJson.post(`merchants/admin/${getMerchantId()}/product-campaigns/`, obj);
}


export function getProductCampaignTemplates_api(search = null) {
    return ajaxJson.get(`merchants/admin/${getMerchantId()}/product-campaign-templates/`, {
        params: {
            search: search
        }
    });
}

export function getProductCampaign_api(search = null) {
    return ajaxJson.get(`merchants/admin/${getMerchantId()}/product-campaigns/`, {
        params: {
            search: search
        }
    });
}

export function getNotificationCampaign_api(search = null) {
    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/bulk-messages/`, {
        params: {
            search: search
        }
    });
}


export function getPhonesOfUsersCampaign_api(id) {
    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/bulk-messages/${id}/users/`);
}


export function activeNotificationCampaignApi(campaignId) {
    return ajaxJson.patch(
        `/merchant_admin/${getMerchantId()}/admin/bulk-messages/${campaignId}/`, {is_active: true}
    );
}

export function deactivateNotificationCampaignApi(campaignId) {
    return ajaxJson.patch(
        `/merchant_admin/${getMerchantId()}/admin/bulk-messages/${campaignId}/`, {is_active: false}
    );
}


//billing

export function getTransactionData_api(from_date, to_date) {
    return ajaxJson.get(`/merchants/admin/${getMerchantId()}/transactions/`, {
        params: {
            from_date: from_date,
            to_date: to_date
        }
    });
}

export function getBillingData_api(from_date, to_date) {
    return ajaxJson.get(`/merchants/admin/${getMerchantId()}/monthly-bills/`, {
        params: {
            from_date: from_date,
            to_date: to_date
        }
    });
}

export function requestToCreditGateWay_api(obj) {
    return ajaxJson.post(`/merchants/admin/${getMerchantId()}/merchant-pay-invoice/`, obj);
}

export function sendToCreditGateWay_api(obj) {
    return ajaxJson.post(`/gateway/create/invoices/`, obj);
}


export function goToGateWay_api(name, sign) {
    return ajaxJson.post(`/gateway/${sign}/pay/gateway/${name}/`, {});
}

export function getUsersOfTag_api(tag) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/customer-tags/${tag}/customers`);
}

export function createRefCampaign_api(obj) {
    return ajaxJson.post(`campaigns/${getMerchantId()}/create-bulk`, obj);
}


export function uploadDeActiveExcel_api(file) {

    let formData = new FormData();
    formData.set("file", file);
    formData.set("merchant_uid", getMerchantId());


    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/deactivate-products/`, formData, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}


//merchant page

export function getMerchantPage_api(merchantId, pageType) {
    return ajaxJson.get(`/merchant_admin/${getMerchantId()}/admin/get-merchant-page/${merchantId}/?page_type=${pageType}`);
}


export function getBillingDetailV2_api(type, page, from_date, to_date) {

    let url = `/merchants/admin/${getMerchantId()}/transaction-details/?type=${type}&page=${page}&`

    if (from_date)
        url += `from_date=${from_date}&to_date=${to_date}`;

    return ajaxJson.get(url);
}

export function getInvoices_api(page, buyType, payStatus, from_date, to_date, searchText) {
    console.log("invoice log : ", page, buyType, payStatus, from_date, to_date, searchText)
    let url =`/merchants/admin/${getMerchantId()}/invoices/v2?page=${page}&`
    if(searchText?.length>0)
        url+=`search=${searchText}&`

    if(buyType?.length>0 && buyType!=="all")
        url+=`payment_method=${buyType}&`

    if(payStatus?.length>0 && payStatus!=="all")
        url+=`state=${payStatus}&`

    console.log("ssdsss : ",from_date)
    if(from_date)
        url+=`real_created_after=${from_date.toISOString()}&`


    if(to_date)
        url+=`real_created_before=${to_date.toISOString()}&`

    return ajaxJson.get(url);
}


export function getOperations_api(page, from_date, to_date,shamsi_date_from,shamsi_date_to) {

    let url = `/merchant_admin/${getMerchantId()}/admin/merchant-offline-invoices-reports`
    return ajaxJson.get(url,{
        params: {
            page: page,
            shamsi_date_from:shamsi_date_from,
            shamsi_date_to:shamsi_date_to
        }
    });
}


export function getCampaignOperations_api(page, from_date, to_date,shamsi_date_from,shamsi_date_to) {

    let url = `/merchant_admin/${getMerchantId()}/admin/merchant-invoices-campaign-reports`
    return ajaxJson.get(url,{
        params: {
            page: page,
            created_from:shamsi_date_from,
            created_to:shamsi_date_to
        }
    });
}


export function getDetailOperation_api(uid) {

    let url = `/merchant_admin/${getMerchantId()}/admin/merchant-offline-invoices-reports/details/${uid}/`
    return ajaxJson.get(url);
}

export function getDetailCampaignOperation_api(shamsi_date) {
    let url = `/merchant_admin/${getMerchantId()}/admin/merchant-invoices-campaign-reports/details/${shamsi_date}/`
    return ajaxJson.get(url);
}

export function getTotalCashDeskOperation_api(from_date,to_date) {

    let url = `/merchant_admin/${getMerchantId()}/admin/merchant-offline-invoices-reports/aggregate`
    return ajaxJson.get(url,{
        params: {
            shamsi_date_from:from_date,
            shamsi_date_to:to_date
        }
    });
}


export function getMatchingList(page) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/products`, {
            params: {
                page:page,
                status: 'multiple_matched',
                multiple_barcode:true
            }
        })
        .then(res => {
            return res.data
        });
}



export function getSeparateCode_api(page,search) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/products`, {
            params: {
                page:page,
                search:search.length?search:null,
                status: "duplicate_shop_code",
                multiple_shop_code:true
            }
        })
        .then(res => {
            return res.data
        });
}

export function acceptProductShopCode_api(uid) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${uid}`,              {
            status: "matched",
        })
        .then(res => {
            return res.data
        });
}

export function deleteProductShopCode_api(uid) {
    return ajaxJson
        .put(`merchant_admin/${getMerchantId()}/admin/products/${uid}`,              {
            status: "rejected_by_operator",
        })
        .then(res => {
            return res.data
        });
}


export function getMultiMatchBarcode_api(barcodes) {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/base-merchant-products`, {
            params: {
                barcodes: barcodes,
                not_in_merchant:true
            }
        })
        .then(res => {
            return res.data
        });
}

// export function getAuditExcel_api() {
//     return ajaxJson
//         .get(`merchant_admin/${getMerchantId()}/admin/comparison-results/export-excel/`)
//         .then(res => {
//             return res
//         });
// }

export function getAuditExcel_api() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/comparison-results/export-excel/`, {
            responseType: 'blob'
        })
        .then(res => {
            return res
        });
}

export function AuditStart_api() {
    return ajaxJson
        .get(`merchant_admin/${getMerchantId()}/admin/compare-products/`)
        .then(res => {
            return res
        });
}


export function getBillInfo_api(bill_uid) {
    return ajaxJson
        .get(`merchants/admin/${getMerchantId()}/monthly-bills/print-bill/${bill_uid}/`)
        .then(res => {
            return res
        });
}

export function getTorobReport_api() {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/torob-panel-info`)
        .then(res => {
            return res
        });
}


export function getPageSections_api() {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/base-merchant-sections/`)
        .then(res => {
            return res
        });
}

export function applyColors_api(obj) {
    return ajaxJson
        .patch(`/merchant_admin/${getMerchantId()}/admin/`,obj)
        .then(res => {
            return res
        });
}

export function applySectionsOrder_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/create-home-page-with-sections/`,obj)
        .then(res => {
            return res
        });
}

export function batchOperationOnProduct_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/products/bulk-action/`,obj)
        .then(res => {
            return res
        });
}

export function getSections_api(obj) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/merchant-selected-sections/`)
        .then(res => {
            return res.data
        });
}


export function getSectionsCats_api(search) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/product-categories/select2`,{
            params:{
                search:search
            }
        })
        .then(res => {
            return res.data
        });
}

export function getSectionsBrand_api(search) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/product-brands/select2`,{
            params:{
                search:search
            }
        })
        .then(res => {
            return res.data
        });
}
export function getDoctors_api(search) {
    return ajaxJson
        .get(`/smartgoal/${getMerchantId()}/doctors/`,{
            params:{
                doctor_name:search
            }
        })
        .then(res => {
            return res.data
        });
}


export function getSectionsProduct_api(search) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/products/select2`,{
            params:{
                search:search
            }
        })
        .then(res => {
            return res.data
        });
}

export function sectionsUpdateLink_api(obj) {
    return ajaxJson
        .post(`merchant_admin/${getMerchantId()}/admin/section-items/bulk-update/`,obj)
        .then(res => {
            return res.data
        });
}


export function topBannerUpdateLink_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/top-banners/bulk-update/`,obj)
        .then(res => {
            return res.data
        });
}

export function uploadSectionImage_api(obj, itemuid) {
    return ajaxJson
        .put(`/merchant_admin/${getMerchantId()}/admin/update-section-item-image/${itemuid}/`, obj, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}

export function uploadTopBannerImage_api(obj, itemuid) {
    return ajaxJson
        .put(`/merchant_admin/${getMerchantId()}/admin/update-top-banner-image/${itemuid}/`, obj, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}

export function searchProductRow_api(search) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/raw-products/`,{
            params:{
                search:search
            }
        })
        .then(res => {
            return res.data
        });
}

export function requestedProduct_api(params) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/requested-products/`,{
            params:{
                page:params.page
            }
        })
        .then(res => {
            return res.data
        });
}


export function sendProductRequest_api(obj) {
    return ajaxJson
        .post(`/merchant_admin/${getMerchantId()}/admin/requested-products/`,obj)
        .then(res => {
            return res.data
        });
}


export function searchBrandProductRow_api(search) {
    return ajaxJson
        .get(`/merchant_admin/${getMerchantId()}/admin/product-brands/select2`,{
            params:{
                search:search
            }
        })
        .then(res => {
            return res.data
        });
}


export function setSmartGoalData_api(obj) {
    return ajaxJson
        .post(`/smartgoal/${getMerchantId()}/sale-goals/`,obj)
        .then(res => {
            return res.data
        });
}

export function updateTargetDeatil_api(id,obj) {
    return ajaxJson
        .patch(`/smartgoal/${getMerchantId()}/sale-goals/${id}/`,obj)
        .then(res => {
            return res.data
        });
}

export function getSmartGoalData_api(filter,type,page,filterUid=null,value_type=null) {
    let params ={
        filter:filter,
        goal_type:type,
        // type:value_type,
        goal_apply_on:value_type,
        page:page,
    }
    if(filterUid){
        if(filter==="brand")
            params['brand']=filterUid
        if(filter==="category")
            params['category']=filterUid
        if(filter==="product")
            params['product']=filterUid
    }

    return ajaxJson
        .get(`/smartgoal/${getMerchantId()}/sale-goals/`,{
            params:params
        })
        .then(res => {
            return res.data
        });
}

export function getCashiersList_api() {
    return ajaxJson
        .get(`/smartgoal/${getMerchantId()}/offline-cashiers/`)
        .then(res => {
            return res.data
        });
}

export function getCashiersDeatil_api(id) {
    return ajaxJson
        .get(`/smartgoal/${getMerchantId()}/offline-cashiers/${id}/partnerships/`)
        .then(res => {
            return res.data
        });
}



export function merchantSaleAmount_api(obj) {
    return ajaxJson
        .post(`/smartgoal/${getMerchantId()}/analytic-amounts/`,obj)
        .then(res => {
            return res.data
        });
}

export function merchantSaleAmountDoctor_api(obj) {
    return ajaxJson
        .post(`/smartgoal/${getMerchantId()}/analytic-amounts/`,obj)
        .then(res => {
            return res.data
        });
}


export function getBrandSelect2_api(search=null) {
    return ajaxJson.get(`merchant_admin/${getMerchantId()}/admin/product-tags/select2`,{
        params: {
            search: search
        }
    }).then(res => {
        return res.data;
    });
}


export function editCashier_api(id,formData) {
    return ajaxJson
        .patch(`/smartgoal/${getMerchantId()}/offline-cashier/${id}/`, formData, {
            timeout: 50000,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
            return res.data
        });
}

export function getTargetDeatil_api(id) {
    return ajaxJson
        .get(`/smartgoal/${getMerchantId()}/offline-cashiers/${id}/partnerships/`)
        .then(res => {
            return res.data
        });
}

export function invoiceAnalytics_api(obj) {
    return ajaxJson
        .post(`/smartgoal/${getMerchantId()}/invoice-analytics/`,obj)
        .then(res => {
            return res.data
        });
}
